"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyClient = void 0;
const CompaniesAdminClient_1 = require("./services/CompaniesAdminClient");
const CompaniesBackofficeClient_1 = require("./services/CompaniesBackofficeClient");
const CompaniesClient_1 = require("./services/CompaniesClient");
const CompanyProfileClient_1 = require("./services/CompanyProfileClient");
const CompanyProspetsBackofficeClient_1 = require("./services/CompanyProspetsBackofficeClient");
const ContactGroupsClientImpl_1 = require("./services/ContactGroupsClientImpl");
const CurrencyClient_1 = require("./services/CurrencyClient");
const LocationClient_1 = require("./services/LocationClient");
const MetricsClient_1 = require("./services/MetricsClient");
const PaymentsClient_1 = require("./services/PaymentsClient");
const ProfileClient_1 = require("./services/ProfileClient");
const SecurityClient_1 = require("./services/SecurityClient");
const UsersAdminClient_1 = require("./services/UsersAdminClient");
const UsersBackofficeClient_1 = require("./services/UsersBackofficeClient");
const UsersClient_1 = require("./services/UsersClient");
const UsersLogClient_1 = require("./services/UsersLogClient");
const MODULE_PREFIX = '/be-listings/company';
class CompanyClient {
    constructor(options) {
        this.companies = new CompaniesClient_1.CompaniesClientImpl(options, MODULE_PREFIX);
        this.companiesAdmin = new CompaniesAdminClient_1.CompaniesAdminClientImpl(options, MODULE_PREFIX);
        this.companiesBackoffice = new CompaniesBackofficeClient_1.CompaniesBackofficeClientImpl(options, MODULE_PREFIX);
        this.companyProspectsBackoffice = new CompanyProspetsBackofficeClient_1.CompanyProspectsBackofficeClientImpl(options, MODULE_PREFIX);
        this.companyProfile = new CompanyProfileClient_1.CompanyProfileClientImpl(options, MODULE_PREFIX);
        this.contactGroups = new ContactGroupsClientImpl_1.ContactGroupsClientImpl(options, MODULE_PREFIX);
        this.currency = new CurrencyClient_1.CurrencyClientImpl(options, MODULE_PREFIX);
        this.location = new LocationClient_1.LocationClientImpl(options, MODULE_PREFIX);
        this.metrics = new MetricsClient_1.MetricsClientImpl(options, MODULE_PREFIX);
        this.payments = new PaymentsClient_1.PaymentsClientImpl(options, MODULE_PREFIX);
        this.profile = new ProfileClient_1.ProfileClientImpl(options, MODULE_PREFIX);
        this.security = new SecurityClient_1.SecurityClientImpl(options, MODULE_PREFIX);
        this.users = new UsersClient_1.UsersClientImpl(options, MODULE_PREFIX);
        this.usersAdmin = new UsersAdminClient_1.UsersAdminClientImpl(options, MODULE_PREFIX);
        this.usersBackoffice = new UsersBackofficeClient_1.UsersBackofficeClientImpl(options, MODULE_PREFIX);
        this.usersLog = new UsersLogClient_1.UsersLogClientImpl(options, MODULE_PREFIX);
    }
}
exports.CompanyClient = CompanyClient;
